import { Card } from "@heroui/react";

import { useTemplateContext } from "../../contexts/TemplateContext";
import { Switch } from "../core/Switch";

export const MobileTemplateButtons = () => {
  const { enable, setEnable, url } = useTemplateContext();

  if (!url) return null;

  return (
    <div className="mobile-template-toggle-wrapper md:hidden">
      <Card className="mobile-template-toggle canvas-overlay-card">
        <Switch
          size="sm"
          isSelected={enable}
          onValueChange={setEnable}
        >
          Template
        </Switch>
      </Card>
    </div>
  );
};
